import { Info } from 'lucide-react';

import { Columns } from '@/types/table';

const COLUMNS: Columns[] = [
  {
    name: 'Member name',
    selector: 'memberName',
    type: 'component',
    componentDataType: 'text',
    width: '200px',
    isBold: true,
    sticky: 'left',
    isSortableByHeader: true
  },
  {
    name: 'Entity',
    selector: 'entity',
    type: 'text',
    width: '200px'
  },
  {
    name: 'Role',
    selector: 'role',
    type: 'text',
    icon: {
      icon: <Info className="h-4 w-4" />,
      direction: 'right'
    },
    cssClass: 'user-role',
    width: '200px'
  },
  {
    name: 'Email',
    selector: 'email',
    type: 'component',
    componentDataType: 'text',
    width: '200px',
    isSortableByHeader: true
  },
  {
    name: 'Mobile',
    selector: 'mobile',
    width: '154px',
    isSortableByHeader: false
  },
  {
    name: 'Profile status',
    selector: 'profileStatus',
    type: 'text',
    width: '164px'
  },
  {
    name: 'Last login',
    selector: 'lastLogin',
    type: 'date',
    width: '154px'
  }
];

export default COLUMNS;
